import React from 'react'

import EditPriceOfferForm from '../../modules/PriceOffer/components/EditPriceOfferForm'
export default function EditPriceOfferPage() {
  return <EditPriceOfferForm />
}
